import { getAuthHeaders, getLocalItem } from './token'

export function getProfileDisplayName(profile) {
  for (const key of ['nickname', 'staff_name', 'username', 'name', 'display_name', 'displayName']) {
    const value = profile?.[key]
    if (typeof value === 'string' && value.trim()) return value.trim()
  }
  return ''
}

// 认证中心会话不等于本站业务会话；用户名本身也不是登录凭据。
export function readHeaderSession() {
  const loggedIn = Boolean(getAuthHeaders()['X-Auth-Token'])
  let profile = null
  try { profile = JSON.parse(getLocalItem('useInfo') || 'null') } catch { /* 损坏资料不影响独立token读取。 */ }
  return { loggedIn, displayName: loggedIn ? getProfileDisplayName(profile) : '' }
}